import { useMemo } from "react"
import { IconCalendarStats } from "@tabler/icons-react"

import { ObjectsTypes } from "@/shared/api"

import styles from "./index.module.css"
import { parseISOToLocalDate } from "@/shared/helpers"

const MeetingObject = ({ item }: { item: ObjectsTypes.RelatedObject }) => {
  const fieldsCollection = useMemo(() => {
    return {
      developer: item.fields[0][2].values[0],
      complex: item.fields[0][3].values[0],
      date: parseISOToLocalDate(item.fields[0][4].values[0]),
      step: item.fields[0][0].values[0],
    }
  }, [item])

  return (
    <div className={styles.Card}>
      <div className={styles.Row}>
        <IconCalendarStats size={14} />
        <div className={styles.Name}>{fieldsCollection.date}</div>
      </div>
      <div className={styles.Info}>
        <div>{fieldsCollection.developer}</div>
        <div>{fieldsCollection.complex}</div>
        <div>Этап: {fieldsCollection.step}</div>
      </div>
    </div>
  )
}

export default MeetingObject
